export function onlyUnique<T>(array: Array<T>) {
  const uniqueArray = [...new Set(array)];
  return uniqueArray;
}
